<template>
    <div class="customer_box">
        <Head title="客服中心"></Head>
        <ul class="customer_list">
            <li class="customer_item" v-for="(item, index) in customerList" :key="index">
                <h1>{{ item.title }}</h1>
                <p>热线电话：{{ item.phone }}</p>
                <p>服务时间：09:00-17:30（法定工作日）</p>
            </li>
        </ul>
    </div>
</template>

<script>
import Head from "./components/headTabs.vue";
export default {
    components: {
        Head,
    },
    data() {
        return {
            customerList: [{
                title: "中文知识网客户服务热线",
                phone: "82615505"
            }, {
                title: "中文知识网-学术会议客户服务热线",
                phone: "82617780"
            }, {
                title: "中文知识网-学术专著客户服务热线",
                phone: "82617780"
            }, {
                title: "中文知识网-教育培训客户服务热线",
                phone: "82615893"
            }, {
                title: "中文知识网-行业报告客户服务热线",
                phone: "82612567"
            }, {
                title: "中文知识网-图书商城客户服务热线",
                phone: "82612767"
            }]
        }
    },
}
</script>

<style lang='scss' scoped>
.customer_box {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 12px;

    .customer_list {
        margin: 12px auto 0;
        width: 351px;

        .customer_item {
            margin-bottom: 12px;
            padding: 15px 13px;
            width: 100%;
            border-radius: 8px;
            background-color: #fff;

            &:last-child {
                margin-bottom: 0;
            }

            h1 {
                margin-bottom: 5px;
                font-size: 15px;
                color: #333333;
                line-height: 21px;
            }

            p {
                margin-top: 9px;
                font-size: 13px;
                color: #999999;
                line-height: 19px;
            }
        }
    }
}
</style>